import React from 'react';

/** 格式化日期 */
function formatDate(dateStr?: string) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

export interface JobApplicationDetailModalProps {
  open: boolean;
  loading: boolean;
  detail: Api.Resume.ApplicationResponse | null;
  onClose: () => void;
}

export const JobApplicationDetailModal: React.FC<JobApplicationDetailModalProps> = ({
  open,
  loading,
  detail,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-foreground-950/40 backdrop-blur-xs">
      <div className="bg-white rounded-3xl max-w-lg w-full p-6 sm:p-8 shadow-2xl relative animate-in fade-in zoom-in-95 duration-200 max-h-[85vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-foreground-400 hover:text-foreground-700 cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        <h3 className="text-lg font-bold text-foreground-950 mb-4 pb-3 border-b border-gray-100">
          职位申请详情
        </h3>

        {loading ? (
          <div className="py-12 text-center">
            <div className="inline-block w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mb-2"></div>
            <p className="text-xs text-foreground-500">正在加载申请详情...</p>
          </div>
        ) : detail ? (
          <div className="space-y-4 text-xs">
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-foreground-400">申请单 ID</span>
              <span className="font-mono text-foreground-900">{detail.id}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-foreground-400">招聘岗位 ID</span>
              <span className="font-mono text-primary-600">{detail.job_posting_id || '未填'}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-foreground-400">申请状态</span>
              <span className="font-medium text-foreground-900">{detail.status || '待处理'}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-foreground-400">申请时间</span>
              <span className="text-foreground-900">{formatDate(detail.applied_at)}</span>
            </div>
            {detail.withdrawn_at && (
              <div className="flex justify-between py-2 border-b border-gray-50">
                <span className="text-foreground-400">撤回时间</span>
                <span className="text-foreground-900">{formatDate(detail.withdrawn_at)}</span>
              </div>
            )}

            {/* 简历快照数据 */}
            {detail.resume_snapshot_json && (
              <div className="pt-2">
                <p className="font-semibold text-foreground-800 mb-2">投递资料快照：</p>
                <pre className="p-3 bg-gray-50 rounded-xl font-mono text-[11px] text-foreground-700 overflow-x-auto border border-gray-200">
                  {JSON.stringify(detail.resume_snapshot_json, null, 2)}
                </pre>
              </div>
            )}
          </div>
        ) : (
          <p className="text-center py-8 text-xs text-foreground-400">未能获取到完整的申请详情数据</p>
        )}

        <div className="mt-6 pt-4 border-t border-gray-100">
          <button
            onClick={onClose}
            className="w-full py-2.5 bg-gray-100 hover:bg-gray-200 text-foreground-700 rounded-xl text-xs font-semibold transition-colors cursor-pointer"
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobApplicationDetailModal;
